import { array, number, object, string } from 'yup';

export const creationSchema = object({
    userId: number().min(1).required(),
    location: object({
        lat: number().required(),
        lng: number().required(),
        address: string().min(3).required(),
    }),
    motives: array().of(string()).optional(),
    channel: string().min(1).required(),
});
